module.exports = __webpack_public_path__ + "img/GF.b747d0a3.svg";